import type { Theme } from '../../themes/themes';

export const createListTheme = (theme: Theme): Partial<Theme> => ({
  components: {
    MuiListItem: {
      styleOverrides: {
        root: {
          '&:not(:last-child)': {
            '& .MuiListItemText-secondary': {
              marginBottom: theme.spacing(8),
              [theme.breakpoints.up('lg')]: {
                marginBottom: theme.spacing(9),
              },
            },
          },

          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: theme.spacing(5),
          [theme.breakpoints.up('lg')]: {
            paddingLeft: theme.spacing(6),
          },
          '.MuiListItemAvatar-root, &::before': {
            textAlign: 'left',
            display: 'flex',
            minWidth: 'auto',
            alignSelf: 'start',
          },
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        primary: {
          paddingBottom: 0,
          marginBottom: theme.spacing(5),
          [theme.breakpoints.up('lg')]: {
            marginBottom: theme.spacing(6),
          },
        },
        secondary: {
          // TODO: Use this until there is a second TextConsumer for just inline styles
          p: {
            marginLeft: 0,
          },
        },
        root: {
          margin: 0,
        },
      },
    },
  },
});
